module.exports = __webpack_public_path__ + "static/media/b.fdb4b990.jpg";